export const background = {
  default: 'hsl(0, 0%, 98.039216%)',
  subtle: 'hsl(0, 0%, 96.078431%)',
}
export const surface = {
  default: 'hsl(0, 0%, 100%)',
  raised: 'hsl(0, 0%, 100%)',
  sunken: 'hsl(0, 0%, 96.078431%)',
}
export const text = {
  default: 'hsl(204, 15.151515%, 6.470588%)',
  muted: 'hsl(201.818182, 7.006369%, 30.784314%)',
  subtle: 'hsl(198, 4.385965%, 55.294118%)',
  inverse: 'hsl(0, 0%, 100%)',
  link: 'hsl(217.2, 100%, 19.607843%)',
}
export const border = {
  default: 'hsl(195, 6.060606%, 87.058824%)',
  subtle: 'hsl(0, 0%, 92.156863%)',
  strong: 'hsl(198, 4.385965%, 55.294118%)',
}
export const action = {
  default: 'hsl(217.2, 100%, 19.607843%)',
  hover: 'hsl(222.545455, 100%, 10.784314%)',
  subtle: 'hsl(196, 100%, 97.058824%)',
}
export const success = {
  surface: 'hsl(110, 50%, 95.294118%)',
  text: 'hsl(121.333333, 100%, 17.647059%)',
  border: 'hsl(115.081967, 35.260116%, 66.078431%)',
  solid: 'hsl(123.043478, 100%, 27.058824%)',
}
export const warning = {
  surface: 'hsl(20, 100%, 96.470588%)',
  text: 'hsl(19.849624, 95.683453%, 27.254902%)',
  border: 'hsl(18, 74.626866%, 73.72549%)',
  solid: 'hsl(23.880597, 100%, 39.411765%)',
}
export const danger = {
  surface: 'hsl(3.75, 100%, 96.862745%)',
  text: 'hsl(347.288136, 90.769231%, 25.490196%)',
  border: 'hsl(358.636364, 67.692308%, 74.509804%)',
  solid: 'hsl(346.626506, 82.178218%, 39.607843%)',
}
export const info = {
  surface: 'hsl(218.571429, 46.666667%, 94.117647%)',
  text: 'hsl(219.74026, 60.629921%, 24.901961%)',
  border: 'hsl(218.181818, 35.106383%, 63.137255%)',
  solid: 'hsl(219.813084, 53.768844%, 39.019608%)',
}
